import { Model, View } from '@lernetz/ts-lib';

import template from './Aside.html';

export class Aside extends Model {

    public readonly color: string;
    public readonly elements: object[];
    public readonly marginTop: string;
    public readonly marginBottom: string;

    public constructor(dto) {
        super();

        this.color = dto.color || '-blue';
        this.elements = dto.elements || [];
        this.marginTop = dto.marginTop || '';
        this.marginBottom = dto.marginBottom || '';
    }
}

export class AsideView extends View<Aside> {

    public constructor() {
        super({ template });
    }
}
